/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChangeRequestGeoPositionRequest } from './ChangeRequestGeoPositionRequest';
import {
    ChangeRequestGeoPositionRequestFromJSON,
    ChangeRequestGeoPositionRequestFromJSONTyped,
    ChangeRequestGeoPositionRequestToJSON,
    ChangeRequestGeoPositionRequestToJSONTyped,
} from './ChangeRequestGeoPositionRequest';

/**
 * 
 * @export
 * @interface ChangeRequestAddressRequest
 */
export interface ChangeRequestAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestAddressRequest
     */
    additional?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestAddressRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestAddressRequest
     */
    countryCode?: string;
    /**
     * 
     * @type {ChangeRequestGeoPositionRequest}
     * @memberof ChangeRequestAddressRequest
     */
    geoPosition?: ChangeRequestGeoPositionRequest;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestAddressRequest
     */
    googlePlaceId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestAddressRequest
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestAddressRequest
     */
    streetNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ChangeRequestAddressRequest
     */
    zip?: string;
}

/**
 * Check if a given object implements the ChangeRequestAddressRequest interface.
 */
export function instanceOfChangeRequestAddressRequest(value: object): value is ChangeRequestAddressRequest {
    return true;
}

export function ChangeRequestAddressRequestFromJSON(json: any): ChangeRequestAddressRequest {
    return ChangeRequestAddressRequestFromJSONTyped(json, false);
}

export function ChangeRequestAddressRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeRequestAddressRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'additional': json['additional'] == null ? undefined : json['additional'],
        'city': json['city'] == null ? undefined : json['city'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'geoPosition': json['geoPosition'] == null ? undefined : ChangeRequestGeoPositionRequestFromJSON(json['geoPosition']),
        'googlePlaceId': json['googlePlaceId'] == null ? undefined : json['googlePlaceId'],
        'street': json['street'] == null ? undefined : json['street'],
        'streetNumber': json['streetNumber'] == null ? undefined : json['streetNumber'],
        'zip': json['zip'] == null ? undefined : json['zip'],
    };
}

export function ChangeRequestAddressRequestToJSON(json: any): ChangeRequestAddressRequest {
    return ChangeRequestAddressRequestToJSONTyped(json, false);
}

export function ChangeRequestAddressRequestToJSONTyped(value?: ChangeRequestAddressRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'additional': value['additional'],
        'city': value['city'],
        'countryCode': value['countryCode'],
        'geoPosition': ChangeRequestGeoPositionRequestToJSON(value['geoPosition']),
        'googlePlaceId': value['googlePlaceId'],
        'street': value['street'],
        'streetNumber': value['streetNumber'],
        'zip': value['zip'],
    };
}

